export class MarkdownParser {
  static parse(text: string): string {
    if (!text || typeof text !== 'string') {
      return text || '';
    }

    let html = this.escapeHtml(text);

    // Bold + Italic (must come before individual bold/italic)
    html = html.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
    html = html.replace(/___(.+?)___/g, '<strong><em>$1</em></strong>');

    // Bold
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');

    // Italic
    html = html.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');
    html = html.replace(/(?<!_)_(?!_)(.+?)(?<!_)_(?!_)/g, '<em>$1</em>');

    // Strikethrough
    html = html.replace(/~~(.+?)~~/g, '<del>$1</del>');

    const emojiMap: Record<string, string> = {
      smile: '\u{1F604}',
      rocket: '\u{1F680}',
      tada: '\u{1F389}',
    };

    html = html.replace(/:([a-z0-9_+-]+):/g, (match, emojiName: string) => {
      return emojiMap[emojiName] ?? match;
    });

    return html;
  }

  static toPlainTextHtml(text: string): string {
    return this.escapeHtml(text).replace(/\n/g, '<br>');
  }

  private static escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
